module.exports = __webpack_public_path__ + "static/media/students-img3.40026e12.svg";